(function () {
  'use strict';

  angular.module('app').component('priceListsPage', PriceListsPageComponent());

  function PriceListsPageComponent() {
    return {
      templateUrl: './app/ajs/price-lists/price-lists-page.component.html',
      controller: PriceListListCtrl,
      controllerAs: 'vm',
      bindings: {},
    };
  }

  PriceListListCtrl.$inject = ['$location', 'AbilityService', 'PriceListService'];

  function PriceListListCtrl($location, AbilityService, PriceListService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.permissions = {
      canCreate: AbilityService.can('create_pricelist_accountadmin'),
    };

    // Initializers
    getItems();

    // public methods
    // -----------------------
    vm.createItem = function () {
      $location.path('/price_lists/new');
    };

    vm.onShowItem = function (item) {
      $location.path(`/price_lists/${item.id}`);
    };

    // private methods
    // -----------------------
    function getItems() {
      vm.loadingItems = true;
      PriceListService.getPriceLists().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }
  }
})();
